// 2_components/dklab_favorites.js
// Customizes the dkLab "favorites" add-on: overrides where its header/detail icons
// are injected (responsive), moves the favorites button into the product image
// slider, and labels the header favorites link.

/* document.addEventListener(
	"dkLabFavouriteProductsHeaderChanged",
	function () {
		let favoritesInHeader = document.querySelector("#header .navigation-buttons #dkLabFavHeaderWrapper");
		if (!favoritesInHeader) return;

		let headerTop = document.querySelector("#header .header-top");
		if (!headerTop) return;

		headerTop.appendChild(favoritesInHeader);
	},
	{ once: true }
); */

export function init() {
	// Change the default position where the favorites add-on is placed.
	if (typeof dkLabOblibeneDataLayer !== "undefined") {
		dkLabOblibeneDataLayer.template.classic.selectors.headerIconAddBefore = "#header .header-top .site-name-wrapper";

		if (window.NAT.media.isSmallTablet) {
			dkLabOblibeneDataLayer.template.classic.selectors.headerIconAddBefore =
				"#header .menu-helper .menu-level-1 > li:first-of-type";
		}

		dkLabOblibeneDataLayer.template.classic.selectors.detailAddLinkDivAfter = ".p-image-wrapper .p-image";

		const imageCarouselWrapper = document.querySelector(".image-carousel-wrapper");
		if (imageCarouselWrapper) {
			dkLabOblibeneDataLayer.template.classic.selectors.detailAddLinkDivAfter =
				".p-image-wrapper .p-image .image-carousel-wrapper";
		}

		if (document.body.classList.contains("type-product")) {
			document.addEventListener("dkLabFavouriteProductsLoaded", function () {
				moveFavouritesDivToSlider();
				function moveFavouritesDivToSlider() {
					if (imageCarouselWrapper) {
						dkLabOblibeneDataLayer.template.classic.selectors.detailAddLinkDivAfter =
							".p-image-wrapper .p-image .image-carousel-wrapper";
					}
					const favoritesInInfoWrapper = document.querySelector(".p-image-wrapper > .dkLabFavouriteDiv");
					if (favoritesInInfoWrapper) {
						const appendFavouritesToThis = document.querySelector(".p-image-wrapper .image-carousel-wrapper");
						if (appendFavouritesToThis) {
							appendFavouritesToThis.appendChild(favoritesInInfoWrapper);
						}
					}
				}
			});
		}

		document.addEventListener("debouncedResize", function () {
			dkLabOblibeneDataLayer.template.classic.selectors.headerIconAddBefore = "#header .header-top .site-name-wrapper";

			if (!window.NAT.media.isSmallTablet) {
				const existingFavInHeader = document.querySelector("#header .menu-helper .menu-level-1 #dkLabFavHeaderWrapper");
				if (existingFavInHeader) {
					const headerTop = document.querySelector("#header .header-top");
					if (!headerTop) return;
					headerTop.prepend(existingFavInHeader);
				}
			}

			if (window.NAT.media.isSmallTablet) {
				dkLabOblibeneDataLayer.template.classic.selectors.headerIconAddBefore =
					"#header .menu-helper .menu-level-1 > li:first-of-type";

				const existingFavInHeader = document.querySelector(".header-top #dkLabFavHeaderWrapper");
				if (existingFavInHeader) {
					const menuLevel1 = document.querySelector("#header .menu-helper .menu-level-1");
					if (!menuLevel1) return;
					menuLevel1.prepend(existingFavInHeader);
				}
			}
		});
	}

	document.addEventListener("dkLabFavouriteProductsHeaderChanged", function () {
		const favoritesInHeader = document.querySelector("#header #dkLabFavHeaderWrapper");
		if (!favoritesInHeader) return;

		const favoritesHref = favoritesInHeader.querySelector("a");
		if (!favoritesHref) return;

		const favoritesSpan = document.createElement("span");
		favoritesSpan.textContent = window.NAT.translations("favorites");
		favoritesHref.prepend(favoritesSpan);

		const em = favoritesInHeader.querySelector("em");
		if (!em) {
			favoritesInHeader.classList.add("no-count");
		} else {
			favoritesInHeader.classList.remove("no-count");
		}
	});
}
